import { startWorkspaceAuth } from '@/lib/api/rome';

export type WorkspaceAuthErrorCode = 'start_failed';

export class WorkspaceAuthError extends Error {
  code: WorkspaceAuthErrorCode;

  constructor(code: WorkspaceAuthErrorCode, message: string) {
    super(message);
    this.name = 'WorkspaceAuthError';
    this.code = code;
  }
}

export interface WorkspaceAuthGrant {
  deviceCode: string;
  expiresIn: number;
  interval: number;
}

interface BeginWorkspaceAuthorizationOptions {
  accessToken: string;
  approvalWindow: Window | null;
  onApprovalUrl?: (url: string, userCode: string) => void;
}

export function openWorkspaceAuthWindow(): Window | null {
  return window.open('about:blank', '_blank', 'popup=yes,width=520,height=720');
}

export async function beginWorkspaceAuthorization({
  accessToken,
  approvalWindow,
  onApprovalUrl,
}: BeginWorkspaceAuthorizationOptions): Promise<WorkspaceAuthGrant> {
  const startResponse = await startWorkspaceAuth(accessToken);
  const startData = startResponse.data?.data;
  if (startResponse.status !== 200 || !startData) {
    approvalWindow?.close();
    throw new WorkspaceAuthError(
      'start_failed',
      startResponse.data?.message || `Workspace auth failed (${startResponse.status})`
    );
  }

  const approvalUrl = startData.verification_uri_complete || startData.verification_uri;
  if (approvalWindow) {
    approvalWindow.location.href = approvalUrl;
  }
  onApprovalUrl?.(approvalUrl, startData.user_code);

  return {
    deviceCode: startData.device_code,
    expiresIn: startData.expires_in,
    interval: startData.interval,
  };
}
